import EditableSelectInputView from "shared/controls/editable_select_input_view";

import ExceptionHandling from "shared/logging/exception_handling";

import jQuery from "jquery";
import _ from "underscore";

import Backbone from "backbone";

const $ = jQuery;

const Select = {
  initAll: function(container) {
    var containerEl = container instanceof jQuery ? container : jQuery('body');

    containerEl.find('input[data-plugin=select2], select[data-plugin=select2]').each(function() {
      var $el = jQuery(this);

      if ($el.data('select2')) {
        return;
      }

      var attrName            = $el.data("select2-attr-name") || $el.attr("name");
      var startingValue       = $el.data("select2-default-value");
      var startingDisplayName = $el.data("select2-default-display-name");
      var placeholderText     = $el.data("select2-placeholder-text");
      var ajaxUrl             = $el.data("select2-ajax-url");
      // default to simple native-like select when no remote datasource is provided
      var simpleSelect        = $el.data("select2-replace") === false || !ajaxUrl;
      var width               = $el.data("select2-width") || $el.prop("style").width || "100%";
      var wrapperClass        = $el.data("select2-wrapper-class") || "select2-wrapper";
      var search              = $el.data("select2-search") || !simpleSelect;
      var modelOptions = {};
      let select2Options = {};

      if (!attrName) {
        ExceptionHandling.logError("select2 data-plugin element does not have required 'data-select2-attr-name' attribute: id=" + $el.attr('id') + ", class=" + $el.attr('class'));
        return;
      }

      if (startingValue) {
        if (!startingDisplayName) {
          ExceptionHandling.logError("select2 data-plugin element must provide 'data-select2-default-display-name' attribute when 'data-select2-default-value' is set: id=" + $el.attr('id') + ", class=" + $el.attr('class'));
          return;
        }
        modelOptions[attrName] = startingValue;
        modelOptions[attrName + "_label"] = startingDisplayName;
      } else if (simpleSelect) {
        modelOptions[attrName] = $el.val();
        modelOptions[attrName + "_label"] = $el.find('option:selected').text();
      }

      var editableSelectInputViewOptions = {
        placeholder: placeholderText || "Select an option below...",
        attr:  attrName,
        width: width,
        model: new Backbone.Model(modelOptions),
        attributes: {
          name: attrName
        },
        href: ajaxUrl,
        el: simpleSelect ? this : null,
        wrapperClass: wrapperClass,
        search: search,
        select2Options: select2Options
      };

      var view = new EditableSelectInputView(editableSelectInputViewOptions);

      var placeholder = $el.wrap('<div>').parent();

      const dom = view.render().$el;
      placeholder.replaceWith(dom);
      dom.find('.select2-initial').data("select2-plugin", view);
    });
  },

  closeAll($el) {
    $el.find('.select2-initial').each(function(_index, el) {
      const $select2 = $(el);

      if ($select2.data("select2")) {
        $select2.select2("destroy");

        const view = $select2.data("select2-plugin");
        view && view.close();
      }
    });
  },

  // Convert all standard selects from the provided container into select2
  // Container can be a jQuery object, view object, selector string
  convertAll: function(container) {
    var containerEl;
    if (container instanceof jQuery) {
      containerEl = container;
    } else if (container && container.$el instanceof jQuery) {
      containerEl = container.$el;
    } else if (typeof container === "string") {
      containerEl = jQuery(container);
    }
    if (containerEl) {
      containerEl.find("select:not([data-select2-ignore])").attr("data-plugin", "select2");
    }
    this.initAll(containerEl);
  },

  // Shared template for our jQuery plugin and React component
  advertiserCampaignTemplateResult: function(item) {
    if (item.loading) {
      return item.text;
    } else {
      var idFromNetwork = _.escape(item.id_from_network) || '—';
      return $("<div>" + _.escape(item.text) + "</div><div class='text-muted'>" + idFromNetwork + "</div>");
    }
  }
};

export default Select;
